<div class="d-flex align-items-center justify-content-between">
    <app-branding></app-branding>

    @if(showToggle) {
    <button
            type="button"
            mat-icon-button
            class="mobile-navigation-close d-flex justify-content-center ng-star-inserted icon-40 align-items-center mat-body-1"
            aria-label="Close navigation"
            aria-controls="mobile-navigation"
            (click)="toggleMobileNav.emit()">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
    }
</div>
